import { defineAsyncComponent } from 'vue'
export default {
  area: defineAsyncComponent(() => import("/tmp/tmpmgt48ojh/layouts/area.vue").then(m => m.default || m)),
  point: defineAsyncComponent(() => import("/tmp/tmpmgt48ojh/layouts/point.vue").then(m => m.default || m)),
  pref: defineAsyncComponent(() => import("/tmp/tmpmgt48ojh/layouts/pref.vue").then(m => m.default || m)),
  ranking: defineAsyncComponent(() => import("/tmp/tmpmgt48ojh/layouts/ranking.vue").then(m => m.default || m)),
  top: defineAsyncComponent(() => import("/tmp/tmpmgt48ojh/layouts/top.vue").then(m => m.default || m))
}